import { ChangeDetectionStrategy, Component, computed, input, InputSignal, Signal } from '@angular/core'
import { AbstractControl, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { TranslatePipe } from '@ngx-translate/core'
import { TuiLabel, TuiNumberFormat, TuiTextfield } from '@taiga-ui/core'
import { TuiInputNumberModule, TuiTextfieldControllerModule } from '@taiga-ui/legacy'
import { TuiInputNumber, TuiSkeleton } from '@taiga-ui/kit'
import { PricePipe } from '@shared/pipes/price.pipe'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import * as en from './core/locale/en.json'
import * as ru from './core/locale/ru.json'
import { InputNumberSignsDirective } from '@shared/directives/input-number-signs.directive'

@UseLocales({ ru, en })
@Component({
	selector: 'app-order-price-input',
	templateUrl: './order-price-input.component.html',
	styleUrl: './order-price-input.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [
		FormsModule,
		ReactiveFormsModule,
		TranslatePipe,
		TuiLabel,
		TuiTextfield,
		TuiInputNumberModule,
		TuiTextfieldControllerModule,
		TuiInputNumber,
		TuiNumberFormat,
		TuiSkeleton,
		PricePipe,
		InputNumberSignsDirective,
	],
})
export class OrderPriceInputComponent {
	public label: InputSignal<string> = input<string>('')
	public control: InputSignal<AbstractControl | null> = input<AbstractControl | null>(null)
	public visibleLabel: InputSignal<boolean> = input<boolean>(true)
	public bidPrice: InputSignal<number | null> = input<number | null>(null)
	public askPrice: InputSignal<number | null> = input<number | null>(null)
	public isLoading: InputSignal<boolean> = input<boolean>(false)
	public step: InputSignal<number> = input<number>(1)
	public icon: InputSignal<string> = input<string>('@tui.dollar-sign')

	protected formControl: Signal<FormControl> = computed<FormControl>((): FormControl => {
		return (this.control() ?? new FormControl()) as FormControl
	})
}
